import { Table, message } from "antd";
import { ColumnsType } from "antd/es/table";
import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import {
  useDeleteContingentMutation,
  useGetContingentMutation,
} from "src/app/services/management";
import { IContingent } from "src/app/services/management/type";
import { useTypedSelector } from "src/app/store";
import PaginationFilter from "src/components/filter/PaginationFilter";
import TableActions from "src/components/view/TableActions";
import ContentTop from "src/layout/content/ContentTop";
import { handleMakeUrl } from "src/utils";
import AddContingent from "./components/AddContingent";
import { contingentsColumns } from "./constants";
import AddRemaining from "./remaining";
import { useTranslation } from "react-i18next";

function ContingentPage() {
  const { t } = useTranslation();
  //Get section
  const [searchParams] = useSearchParams();
  const [getContingent, { data: contingentsData, isLoading }] =
    useGetContingentMutation();
  const { contingents } = useTypedSelector((state) => state.contingent);
  const handleGet = () => {
    let url = handleMakeUrl(searchParams);
    getContingent(url);
  };
  useEffect(() => {
    handleGet();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);

  //Delete section
  const [deleteContingent, { isSuccess: deleteStatus }] =
    useDeleteContingentMutation();
  useEffect(() => {
    if (deleteStatus) {
      handleGet();
      message.success("Item deleted successfully!");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteStatus]);

  //Edit section
  const [editableData, setEditableData] = useState<IContingent>();

  const onEdit = (val: number) => {
    let obj = contingents?.find((el) => el.id === val);
    if (obj) setEditableData(obj);
  };

  //Table section
  const columns: ColumnsType<IContingent> = [
    ...contingentsColumns(t),
    {
      title: t("subInfo.initial_money"),
      dataIndex: "key",
      key: "key",
      render: (_, val) => (
        <AddRemaining
          id={val.id}
          title={val.first_name}
          type={val.is_customer ? "customer" : "supplier"}
        />
      ),
    },
    {
      title: t("common.actions"),
      dataIndex: "key",
      key: "key",
      width: 90,
      fixed: "right",
      render: (key) => (
        <TableActions
          onDelete={() => deleteContingent(key)}
          onEdit={() => onEdit(key)}
        />
      ),
    },
  ];

  return (
    <div>
      <ContentTop>
        <AddContingent
          handleGet={handleGet}
          editableData={editableData}
          setEditableData={setEditableData}
        />
      </ContentTop>

      <Table
        columns={columns}
        dataSource={contingents}
        scroll={{ x: 800 }}
        pagination={false}
        loading={isLoading}
      />
      {contingentsData && <PaginationFilter total={contingentsData?.count} />}
    </div>
  );
}

export default ContingentPage;
